module.exports = __webpack_public_path__ + "static/filtry_FWPiPionoweFWL-133a1590b34513d3e5d54d58028f9f4c.pdf";